import React, { Fragment, useEffect, useState } from 'react';
import { CardBody, Col, Row, Tooltip } from "reactstrap";
import Card from 'components/PurpleTheme/Card';
import Select from "react-select";
import './styles.scss';
import Calendar from "echarts/src/coord/calendar/Calendar";
import OnCallCalender from "./OnCallCalender";
import timeOptions from "./timeOptions";
import timeDurationOptions from "./AvailableTimeDuration";
import {showNotification} from "../../components/Common/notification";
import {clearColorForUser, getUserColor, getUserColorForOncall} from "../../helpers/component_helpers";

const RotationPolicyRow = ({ policy, index, onChange, onRemove, addUser, availableUsers, removeUser }) => {
  const handleSelectUser = (selectedOption) => {
    const selectedUserId = selectedOption.value;
    addUser(index, selectedUserId);
  };
  const [calenderData, setCalenderData] = useState([]);

  const availableUserOptions = availableUsers?.map((user) => ({ label: user.name, value: user.id }));

  const [tooltip, setTooltip] = useState(false);
  const [tooltipEligible, setTooltipEligible] = useState(false);

  const [rotationFrequency, setRotationFrequency] = useState(policy?.rotation_frequency);
  const handleRotationFrequency = (e) => {
    setRotationFrequency(e.value);
    onChange(index, 'rotation_frequency', e.value);
  }
  const [tooltipShow, setTooltipShow] = useState(false);
  const formatTime = (hours, minutes) =>
      `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;

  const [selectedShiftStartTime, setSelectShitStartTime] = useState(
      timeOptions.find(option =>
          option.label === formatTime(policy?.shift_start_time_hours, policy?.shift_start_time_minutes)
      )
  );

  const [selectedShiftEndTime, setSelectShitEndTime] = useState(
      timeOptions.find(option =>
          option.label === formatTime(policy?.shift_end_time_hours, policy?.shift_end_time_minutes))
  );
  const [shiftDuration, setShiftDuration] = useState(
      timeDurationOptions.find(
          (option) =>
              option.label === `${policy?.shift_duration_hours}:${policy?.shift_duration_minutes}`
      )
  )
  const handleTimeChangeStart = (e) => {
    const [hours, minutes] = e.value.split(':');
    // const startTimeInMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
    // const endTimeInMinutes = parseInt(policy.shift_end_time_hours, 10) * 60 + parseInt(policy.shift_end_time_minutes, 10);
    // const shiftDurationInMinutes = parseInt(policy.shift_duration_hours) * 60 + parseInt(policy.shift_duration_minutes);
    // let totalAvailableMinutes = Math.abs(endTimeInMinutes - startTimeInMinutes);
    //     if (totalAvailableMinutes === 0) {
    //         totalAvailableMinutes = 1440;
    //     }
    // if (shiftDurationInMinutes > totalAvailableMinutes) {
    //   showNotification('error', "Shift duration cannot exceed the available time between start and end time.");
    //   const error = null;
    //   setSelectShitStartTime(error);
    //   return;
    // }
    setSelectShitStartTime(e)
    onChange(index, 'shift_start_time_minutes', minutes);
    onChange(index, 'shift_start_time_hours', hours);
  }

  const handleTimeChangeEnd = (e) => {
    const [hours, minutes] = e.value.split(':');
    // const endTimeInMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
    // const startTimeInMinutes = parseInt(policy.shift_start_time_hours, 10) * 60 + parseInt(policy.shift_start_time_minutes, 10);
    // const shiftDurationInMinutes = parseInt(policy.shift_duration_hours) * 60 + parseInt(policy.shift_duration_minutes);
    // let totalAvailableMinutes = Math.abs(endTimeInMinutes - startTimeInMinutes);
    //     if (totalAvailableMinutes === 0) {
    //         totalAvailableMinutes = 1440;
    //     }
    // if (shiftDurationInMinutes > totalAvailableMinutes) {
    //   showNotification('error', "Shift duration cannot exceed the available time between start and end time.");
    //   const error = null;
    //   setSelectShitEndTime(error);
    //   return;
    // }

    setSelectShitEndTime(e);
    onChange(index, 'shift_end_time_minutes', minutes);
    onChange(index, 'shift_end_time_hours', hours);
  }

  const handleTimeChange = (e) => {
    const [hours, minutes] = e.value.split(':');
    // const shiftDurationInMinutes = parseInt(hours) * 60 + parseInt(minutes);
    // const startTimeInMinutes = parseInt(policy.shift_start_time_hours) * 60 + parseInt(policy.shift_start_time_minutes);
    // const endTimeInMinutes = parseInt(policy.shift_end_time_hours) * 60 + parseInt(policy.shift_end_time_minutes);
    // let totalAvailableMinutes = Math.abs(endTimeInMinutes - startTimeInMinutes);
    // if (totalAvailableMinutes === 0) {
    //   totalAvailableMinutes = 1440;
    // }
    // if (shiftDurationInMinutes > totalAvailableMinutes) {
    //   showNotification('error', "Shift duration cannot exceed the available time between start and end time.");
    //   const error = null;
    //   setShiftDuration(error);
    //   return;
    // }
    setShiftDuration(e);
    onChange(index, 'shift_duration_minutes', minutes);
    onChange(index, 'shift_duration_hours', hours);
  }



  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      position:"absolute",
      background: '#382b42', // Background color of the dropdown menu
      zIndex: 999,
    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100, 
    }),
  };

  const rotationFrequencyOptions = [{ label: 'Weekly', value: 'Weekly' }, { label: 'Daily', value: 'Daily' }, { label: 'Custom', value: 'Custom' }];
  const [btnHover, setBtnHover] = useState(false);
  const customOptionRenderer = (option) => {
    if (option.value === "/organization?tab=3") {
      return (
        <div
          className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{cursor:"pointer"}}>
          <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`} />
          <span>
                {option.label}
              </span>

        </div>
      );
    } else {
      return option.label;
    }
  };

  return (
    <Fragment>
      <Card>
        <div className='d-flex flex-column gap-4'>
          <div className="w-100">
            <CardBody>
              <h5 className="col-md-8">Level {index + 1}</h5>
              <div className="d-flex gap-2 w-100">
                <div style={{width:'100%'}}>
                  <div className='d-flex flex-row justify-content-between pe-5'>
                      <div className='d-flex flex-row'>
                        <div className="align-items-center d-flex me-1" style={{fontSize: '15px'}}>Escalate at</div>
                        <div className="d-flex align-items-center">
                          <input
                              className="input"
                              type="number"
                              id="example-number-input"
                              value={policy?.escalation_time}
                              onChange={(e) => onChange(index, 'escalation_time', e.target.value)}
                              style={{width: '40%', paddingTop: '1px', paddingBottom: '1px'}}
                          />
                          <p className='text-minutes'>minutes(if not acknowledged)</p>
                        </div>
                      </div>
                      <div style={{marginRight:'4rem'}} className='d-flex flex-row'>
                        <div className="align-items-center d-flex me-1" style={{fontSize: '15px'}}>Rotation Frequency</div>
                        <div className="d-flex align-items-center">
                          <Select
                              className="select2-selection"
                              value={rotationFrequencyOptions.find((option) => option.value === rotationFrequency)}
                              options={rotationFrequencyOptions}
                              onChange={handleRotationFrequency}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  neutral0: '#222736',
                                  neutral5: '#485EC4',
                                  neutral10: '#485EC4',
                                  neutral60: '#ffffff',
                                  neutral70: '#ffffff',
                                  neutral80: '#ffffff',
                                  neutral90: '#ffffff',
                                  primary: '#485EC4',
                                },
                              })}
                              styles={customStyles}
                          >
                          </Select>
                        </div>
                      </div>
                      <div style={{width:'34%'}} className='d-flex flex-row'>
                        <div className="align-items-center d-flex me-1" style={{fontSize: '15px'}}>Oncall Engineers
                          <div
                              id="TooltipRight"
                              onMouseOver={() => setTooltip(true)}
                              onMouseLeave={() => setTooltip(false)}
                              className="alert-icon p-1">
                          <i className="mdi mdi-information-outline text-warning"/>
                        </div>
                          <Tooltip
                              placement="right"
                              isOpen={tooltip}
                              target="TooltipRight"
                              toggle={() => {
                                setTooltip(!tooltip);
                              }}
                              style={{
                                border: "2px solid #f1b44c",
                                borderRadius: "10px",
                                backgroundColor: "#2a3042",
                                zIndex: 1
                              }}
                          >
                            On-call will be rotated in the order they are added and based on the rotation frequency.
                          </Tooltip>
                        </div>
                        <div className='d-flex align-items-center gap-1' style={{width:'60%'}}>
                          <div style={{width:'90%'}}>
                            <Select
                                isClearable
                                value={null}
                                maxMenuHeight={100}
                                placeholder="Add user"
                                onChange={(options) => {
                                  if (options && options.value === "/organization?tab=3") {
                                    window.location.href = options.value;
                                  } else {
                                    handleSelectUser(options);
                                  }
                                }}
                                options={[
                                  ...availableUserOptions,
                                  {label: 'Add new user', value: "/organization?tab=3"}
                                ]}
                                className="select2-selection col-form-label customSelect"
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 0,
                                  colors: {
                                    ...theme.colors,
                                    neutral0: '#222736',
                                    neutral5: '#485EC4',
                                    neutral10: '#485EC4',
                                    neutral60: '#ffffff',
                                    neutral70: '#ffffff',
                                    neutral80: '#ffffff',
                                    neutral90: '#ffffff',
                                    primary: '#485EC4',
                                  },
                                })}
                                styles={customStyles}
                                getOptionLabel={(option) => customOptionRenderer(option)}
                            />
                          </div>
                          <span
                              id="TooltipEligible"
                              onMouseOver={() => setTooltipEligible(true)}
                              onMouseLeave={() => setTooltipEligible(false)}
                              className="alert-icon">
                            <i className="mdi mdi-information-outline text-warning"
                               style={{fontSize:'15px'}}/>
                          </span>
                          <Tooltip
                              placement="right"
                              isOpen={tooltipEligible}
                              target="TooltipEligible"
                              toggle={() => {
                                setTooltipEligible(!tooltipEligible);
                              }}
                              style={{
                                border: "2px solid #f1b44c",
                                borderRadius: "10px",
                                backgroundColor: "#2a3042",
                                zIndex: 1,
                              }}
                          >
                            On-call Engineers with verified phone numbers are only eligible.
                          </Tooltip>
                        </div>
                      </div>
                    {index !== 0 && (
                        // Check if it's not the first policy
                        <div className="mt-2 action-icon text-danger">
                          <i className="mdi mdi-trash-can font-size-24 remove-icon" onClick={onRemove}/>
                        </div>
                    )}
                  </div>
                  <div className="user-pills-container">
                    {policy.rotation_users.map((userId, userIndex) => {
                      const user = availableUsers?.find((user) => user.id === userId);
                      return (
                          <span style = {{backgroundColor: getUserColorForOncall(user?.id)}} key={userIndex} className="user-pill">
                            <h4 className='user-name col-md-12 col-form-label'>{user?.name || 'Invalid User'}
                              <i className="mdi mdi-close-thick remove-user-icon"
                                 onClick={() => {
                                   removeUser(index, userIndex)
                                   clearColorForUser(user?.id)
                                 }}>
                              </i>
                            </h4>
                          </span>
                      );
                    })}
                  </div>
                  {rotationFrequency === 'Custom' && (
                      <div className='d-flex flex-column w-100 gap-1 mt-2 align-items-start'>
                        <div className='d-flex flex-row gap-5 mb-2 w-100'>
                          <div className='d-flex flex-column' style={{width:'40%',paddingTop:'0.1rem'}}>
                            <div className="d-flex align-items-center mb-1" style={{fontSize: '15px'}}>Rotation Time</div>
                            <div className='d-flex flex-row gap-3'>
                              <div style={{width: '50%'}}>
                                <Select
                                    className="select2-selection"
                                    value={selectedShiftStartTime}
                                    options={timeOptions}
                                    onChange={(e)=>handleTimeChangeStart(e)}
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: 0,
                                      colors: {
                                        ...theme.colors,
                                        neutral0: '#222736',
                                        neutral5: '#485EC4',
                                        neutral10: '#485EC4',
                                        neutral60: '#ffffff',
                                        neutral70: '#ffffff',
                                        neutral80: '#ffffff',
                                        neutral90: '#ffffff',
                                        primary: '#485EC4',
                                      },
                                    })}
                                    styles={customStyles}
                                    maxMenuHeight={100}
                                    placeholder={'Select start Time'}
                                >
                                </Select>
                              </div>
                              <div style={{width: '50%'}}>
                                <Select
                                    className="select2-selection"
                                    value={selectedShiftEndTime}
                                    options={timeOptions}
                                    onChange={(e)=>{handleTimeChangeEnd(e)}}
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: 0,
                                      colors: {
                                        ...theme.colors,
                                        neutral0: '#222736',
                                        neutral5: '#485EC4',
                                        neutral10: '#485EC4',
                                        neutral60: '#ffffff',
                                        neutral70: '#ffffff',
                                        neutral80: '#ffffff',
                                        neutral90: '#ffffff',
                                        primary: '#485EC4',
                                      },
                                    })}
                                    styles={customStyles}
                                    maxMenuHeight={100}
                                    placeholder={'Select End Time'}
                                >
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div style={{width:'35%'}} className='d-flex flex-column'>
                            <div className="d-flex align-items-center" style={{fontSize: '15px'}}>Shift Duration
                              Frequency
                              <span
                                  id="TooltipRightCustom"
                                  onMouseOver={() => setTooltipShow(true)}
                                  onMouseLeave={() => setTooltipShow(false)}
                                  className="alert-icon ms-1 px-1">
                              <i className="mdi mdi-information-outline text-warning"/>
                            </span>
                              <Tooltip
                                  placement="right"
                                  isOpen={tooltipShow}
                                  target="TooltipRightCustom"
                                  toggle={() => {
                                    setTooltipShow(!tooltipShow);
                                  }}
                                  style={{
                                    border: "2px solid #f1b44c",
                                    borderRadius: "10px",
                                    backgroundColor: "#2a3042",
                                    zIndex: 1
                                  }}
                              >
                                Shift duration frequency is the time period of shift rotation.
                              </Tooltip>
                            </div>
                            <div style={{width:'60%'}}>
                              <Select
                                  className="select2-selection"
                                  value={shiftDuration}
                                  options={timeDurationOptions}
                                  onChange={(e)=>{handleTimeChange(e)}}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      neutral0: '#222736',
                                      neutral5: '#485EC4',
                                      neutral10: '#485EC4',
                                      neutral60: '#ffffff',
                                      neutral70: '#ffffff',
                                      neutral80: '#ffffff',
                                      neutral90: '#ffffff',
                                      primary: '#485EC4',
                                    },
                                  })}
                                  styles={customStyles}
                                  maxMenuHeight={100}
                                  placeholder={'Select shift Duration'}
                              >
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                  )}
                </div>
              </div>
            </CardBody>
          </div>
          <div className="w-100">
            <OnCallCalender
                policy={policy}
                availableUsers={availableUsers}
                timezone={policy.timezone}
                deletedUsers={[]}
            />
          </div>
        </div>
      </Card>
    </Fragment>
  );
};

export default RotationPolicyRow;